
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M35.913 16.4a10.04 10.04 0 01-2.479.708c.399-.069.986-.787 1.22-1.078.354-.439.625-.94.797-1.477 0-.04.04-.097 0-.126a.136.136 0 00-.13 0 12.53 12.53 0 01-2.936 1.14.205.205 0 01-.205-.05 2.86 2.86 0 00-.256-.269 5.347 5.347 0 00-1.402-.906 4.925 4.925 0 00-2.183-.36c-.723.046-1.43.24-2.074.57a5.374 5.374 0 00-1.642 1.392 5.273 5.273 0 00-.997 1.997 5.486 5.486 0 00-.051 2.11c0 .12 0 .137-.103.12-4.063-.599-7.397-2.042-10.121-5.14-.12-.136-.183-.136-.28 0-1.185 1.803-.61 4.655.873 6.064.2.188.404.37.62.542a5.085 5.085 0 01-1.948-.542c-.114-.074-.177-.034-.183.103-.016.19-.016.38 0 .57a5.18 5.18 0 003.192 4.13c.207.089.423.155.644.2a5.825 5.825 0 01-1.91.056c-.136-.028-.187.046-.136.177.838 2.282 2.655 2.978 3.99 3.366.181.028.364.028.569.074l-.034.034c-.393.719-1.983 1.204-2.713 1.455a9.743 9.743 0 01-4.16.536c-.222-.034-.274-.029-.33 0-.058.028 0 .091.062.148.285.188.57.354.866.513.882.482 1.815.865 2.781 1.141 5.004 1.38 10.635.365 14.39-3.37 2.952-2.933 3.99-6.977 3.99-11.027 0-.154.188-.245.296-.325a9.79 9.79 0 001.955-2.042.599.599 0 00.136-.41c0-.086 0-.069-.108-.023z","fill":"#1D1D1D"}})])
          )
        }
      }
    